import { Breadcrumb } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { buildChain, resolveHref } from './matchPath';
import { useBreadcrumbContext } from './BreadcrumbContext';

/**
 * Breadcrumb que reacciona al pathname actual. Se monta una sola vez en
 * LayoutMain y aplica a todas las páginas autenticadas.
 *
 * No renderiza nada cuando:
 *   - El pathname no matchea ningún nodo de la config.
 *   - El pathname matchea un nodo `root: true` (raíz del userType).
 */
export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const { dynamicLabels } = useBreadcrumbContext();
  const chain = buildChain(pathname);

  if (chain.length === 0) return null;
  if (chain.length === 1 && chain[0].node.root) return null;

  const items = chain.map(({ node, params }, idx) => {
    const isLast = idx === chain.length - 1;
    const label = typeof node.label === 'function' ? node.label(params, dynamicLabels) : node.label;
    const href = resolveHref(node.match, params);
    return {
      key: href,
      title: isLast ? <span>{label}</span> : <Link to={href}>{label}</Link>,
    };
  });

  return (
    <div style={{ marginBottom: 12 }}>
      <Breadcrumb items={items} />
    </div>
  );
}
